import { z } from 'zod';

export const CreateExpiredStockAdjustmentSchema = z.object({
    items: z.array(
        z.object({
            purchaseItemId: z.string(),
            productVariationId: z.string(),
            productName: z.string().optional(),
            brandName: z.string().optional(),
            quantity: z.coerce.number().optional(),
            purchasePrice: z.coerce.number().optional(),
            wholesalePrice: z.coerce.number().optional(),
            retailPrice: z.coerce.number().optional(),
            expirationDate: z.coerce.string().optional(),
            updatedPurchasePrice: z.coerce.number().optional(),
        }),
    ),

    total_paid_amount: z.coerce.number(),
    note: z.string().optional(),
    supplier_id: z.string().optional(),
    supplier_name: z.string().optional(),
});

export type TCreateExpiredStockAdjustment = z.infer<
    typeof CreateExpiredStockAdjustmentSchema
>;

export const INITIAL_VALUES: TCreateExpiredStockAdjustment = {
    items: [],
    total_paid_amount: 0,
};
